export const isValidMove = (_from: string, _to: string, _piece: string, _position: Record<string, string>): boolean => {
  // Implement chess move validation
  return true;
};

export const generateFEN = (_position: Record<string, string>): string => {
  // Implement FEN string generation
  return '';
}; 